/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { themeV2, pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPANDABLE SECTION -  SECTION GROUP DESC : STYLES --------------- ++++++++++ */
export default theme => ({
  sectiongroupdescription: {
    '& > h4': {
      marginTop: pxToEm(8),
    },
    '& > h2': {
      marginBottom: pxToEm(10),
      '& i': {
        position: 'relative',
        top: pxToEm(1),
        color: themeV2.color.base.gray.dark
      },
      '& .link': {
        marginLeft: pxToEm(10)
      }
    },
    '& > .scheduledEmailTitle':{
      fontFamily: "Work Sans",
      fontSize: pxToEm(16),
      fontStyle: 'normal',
      fontWeight: '500',
      lineHeight: pxToEm(22),
    },
    '& > .disableScheduledEmailTitle':{
      opacity: '0.2',
      pointerEvents: 'none',
      cursor: 'not-allowed'
    },
    '& > .scheduleEmailReportDescription': {
      fontStyle: 'italic',
      fontWeight: '500',
      lineHeight: 'normal',
      fontSize: pxToEm(13),
    },
    '& > .disableScheduledEmailReportDescription': {
      opacity: '0.2',
      pointerEvents: 'none',
      cursor: 'not-allowed'
    }
  }
});
